import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
//import 'rxjs/add/observable/of';
//import { Subscription } from 'rxjs/Subscription';
import { Utility } from '../../../common/utility';
import { AppMessages } from '../../../shared/constants/messages';
import { AppConstants } from '../../../shared/constants/constants';
//import { Page } from '../../../models/list/page.model';
import { ManageMemoModel } from '../../../models/centre/manage-memo.model';
import { DialogService } from '../../../shared/services/dialog.service';
import { SharedService } from '../../../shared/services/share.services';
import { ManageMemoService } from './manage-memo.service';
import { ModifyNewPopUpComponent } from './modify-news-popup.component';
import { TMBDataTableComponent } from '../../../components/data-table/data-table.component';

@Component({
    selector: 'app-manage-memo',
    templateUrl: './manage-memo.component.html',
    providers: [ManageMemoService]

})
export class ManageMemoComponent extends TMBDataTableComponent implements OnInit, OnDestroy {
   /*  private subscription: Subscription;
    public appConstants = AppConstants;
    page = new Page();

    dataMessage = {
        emptyMessage: AppMessages.list.noRecord, // Message to show when array is presented but contains no values
        totalMessage: AppMessages.list.total // Footer total message
    };
    customClasses = AppConstants.table.footerClasses; */

    dataRow = new Array<ManageMemoModel>();
    constructor(
        public manageMemoService: ManageMemoService,
        public sharedService: SharedService,
        public dialogService: DialogService,
        public utility: Utility) {
            super(sharedService);
    }

    ngOnInit() {
        this.setPage({ offset: 0 });
    }

    setPage(pageInfo) {
        this.page.pageNumber = pageInfo.offset;
        const param = {
            pageSize: this.page.size,
            currentPage: this.page.pageNumber + 1,
            countryId: localStorage.getItem(AppConstants.localStorage.countryId),
            userId: localStorage.getItem(AppConstants.activeLink.userId),
        };
        this.manageMemoService.getAllClinicNew(param).subscribe(
            result => {
                if (result) {
                    const data = result.json();
                    this.dataRow = data['list'];
                    this.dataRow.forEach(element => {
                        if (element.isPublish === false) {
                            element.publishBy = '';
                            element.publishDate = '';
                        }
                    });

                    this.page.pageNumber = pageInfo.offset;
                    this.page.totalElements = data['totalRecords'];
                }
            }
        );

    }
    onRemoveItem(id) {
        this.dialogService.openConfirmationDialog({ message: AppMessages.dialog.confirmMessage1 }).subscribe(
            (result) => {
                if (result) {
                    this.manageMemoService.removeMemo(id).subscribe(
                        result1 => {
                            if (result1) {
                              this.reloadPage(this.page.pageNumber, this.dataRow, true);
                            }
                        }
                    );
                }
            });
    }

    onEditItem(id) {
        this.dialogService.openComponentDialog(ModifyNewPopUpComponent,
            { id: id },
            { width: '750px' }).subscribe(
            result => {
                if (result) {
                  this.reloadPage(this.page.pageNumber, this.dataRow);
                }
            }
            );
    }

    onAddNewMemo(): void {
        this.dialogService.openComponentDialog(ModifyNewPopUpComponent,
            {},
            { width: '750px' }).subscribe(
            (result) => {
                if (result) {
                  this.reloadPage(this.page.pageNumber, this.dataRow);
                }

            }
            );
    }

}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/centre/manage-memo/manage-memo.component.ts